import { gql } from '@apollo/client'
import { ID, IQueryBasicDataWithParameters } from '../IQueryData'

export interface IUnassignUserFromParkingPoolData {
  unassignUserFromParkingPool: IQueryBasicDataWithParameters
}

export interface IUnassignUserFromParkingPoolVars {
  pool: ID
  login: string
}

export const UNASSIGN_USER_FROM_PARKING_POOL = gql`
  mutation unassignUserFromParkingPool($pool: ID!, $login: String!) {
    unassignUserFromParkingPool(pool: $pool, login: $login) {
      status
      code
      message
      error
      parameters {
        name
        value
      }
    }
  }
`
